module.exports = __webpack_public_path__ + "img/404.f41d1918.jpg";